//src/config/apiConfig.jsx BASE_URL: 'http://192.168.0.63:3000/api',
export const API_CONFIG = {
  // Para producción separada: usar import.meta.env.VITE_API_URL
  // Para producción unida (monolito): usar '/api' 
  // Para dev local: detectar el hostname actual (192.168.x.x o localhost)
  BASE_URL: import.meta.env.VITE_API_URL 
              || (window.location.hostname === 'localhost' || window.location.hostname.startsWith('192.168') || window.location.hostname.startsWith('172.') || window.location.hostname.startsWith('10.') 
                  ? `http://${window.location.hostname}:3000/api` 
                  : '/api'),
};

export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

export const useApiConfig = () => {
  return {
    baseUrl: API_CONFIG.BASE_URL,
    getUrl: getApiUrl,
  };
};